import { refreshAuthSession } from "@/lib/auth-client";
import { useMutation } from "@tanstack/react-query";

export function useAuthRefreshAuthSession() {
  return useMutation({
    mutationFn: (args: Parameters<typeof refreshAuthSession>) => refreshAuthSession(...args),
    retry: false,
    gcTime: 0,
  });
}
